<template>
  <div id="examineIntegrate">
    <div class="header flex-between">
      <div class="header-text">
        <h1>GIADA Friends管理-查看-积分明细</h1>
      </div>

      <div class="header-button">
        <el-button class="push-button" icon="iconfont icon-fanhui" plain @click="backHistory">返回</el-button>
      </div>
    </div>
    <div class="flex-between">
      <div class="header-center flex-between">
        <div class="tabs" style="width: 1208px; margin-top: 10px">
          <el-card shadow="never" style="height: 80vh">
            <div class="demo-input-suffix flex-between">
              <el-form
                :inline="true"
                :model="integralInfo"
                class="demo-form-inline"
                size="mini"
                :label-position="labelPosition"
              >
                <el-form-item label="当前可用积分">
                  <el-input
                    :value="integralInfo.currAvailPoint?integralInfo.currAvailPoint:'0'"
                    readonly
                  ></el-input>
                </el-form-item>
                <el-form-item label="待生效积分" style="margin-left: 40px">
                  <el-input
                    :value="integralInfo.pendingPoints?integralInfo.pendingPoints:0"
                    readonly
                  ></el-input>
                </el-form-item>
                <el-form-item label="即将过期积分" style="margin-left: 40px">
                  <el-input
                    :value="integralInfo.pendingInvalidPoints?integralInfo.pendingInvalidPoints:'0'"
                    readonly
                  ></el-input>
                </el-form-item>
              </el-form>
            </div>
            <!-- 表格 -->
            <div>
              <el-table
                size="small"
                class="table-style"
                border
                :row-class-name="tableRowClassName"
                :header-cell-style="{
            background: '#FCFBF2',
            'text-align': 'center',
            color: '#6C6839',
            fontSize: '14px',
          }"
                :cell-style="{ 'text-align': 'center' }"
                ref="multipleTable"
                :data="tableData"
                tooltip-effect="dark"
                style="width: 100%"
                height="560px"
                v-el-table-infinite-scroll="load"
                v-loading="loading"
                infinite-scroll-disabled="onLoading"
              >
                <el-table-column type="index" width="45"></el-table-column>
                <el-table-column prop="name" label="变更日期">
                  <template slot-scope="scope">{{ scope.row.chgDate | dateFormat }}</template>
                </el-table-column>
                <el-table-column prop="points" label="积分"></el-table-column>
                <el-table-column prop="chgKind" label="变更类型">
                  <template slot-scope="scope">
                    {{
                    scope.row.chgKind == 0
                    ? "销售积分"
                    : scope.row.chgKind == 1
                    ? "补积分"
                    : scope.row.chgKind == 2
                    ? "积分过期"
                    : scope.row.chgKind == 3
                    ? "积分兑换"
                    : scope.row.chgKind == 4
                    ? "积分兑换废弃"
                    : scope.row.chgKind == 5
                    ? "异业券使用赠送积分"
                    : scope.row.chgKind == 6
                    ? "异业券使用销售单退货扣减积分"
                    : scope.row.chgKind == 7
                    ? "营销积分"
                    : ""
                    }}
                  </template>
                </el-table-column>
                <el-table-column prop="bindSheetNo" label="业务单据号"></el-table-column>
                <el-table-column prop="startDate" label="积分生效日期">
                  <template slot-scope="scope">{{ scope.row.startDate | dateFormat }}</template>
                </el-table-column>
                <el-table-column prop="custName" label="兑换顾客"></el-table-column>
                <el-table-column prop="state" label="状态">
                  <template slot-scope="scope">{{ scope.row.state == '0' ? "已生效" : "未生效" }}</template>
                </el-table-column>
                <el-table-column prop="chgRemark" label="备注"></el-table-column>
                <el-table-column prop="createTime" label="创建时间">
                  <template slot-scope="scope">{{ scope.row.createTime | dateFormat }}</template>
                </el-table-column>
              </el-table>
              <el-alert
                v-if="total<=tableData.length"
                title="没有更多数据了!"
                type="warning"
                center
                :closable="false"
              ></el-alert>
            </div>
          </el-card>
        </div>
        <!-- 右侧列表相关链接 -->
        <!-- 使用封装的组件 -->
        <div style="margin-top: 10px; margin-left: 30px">
          <Rightcards :GFCrmID="queryInfo.GFCrmID"></Rightcards>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getPointInfo, getPointTable } from "@/api/friends";
export default {
  name: "centre",
  components: {},
  data() {
    return {
      activeName: "first",
      labelPosition: "top",
      integralInfo: {}, //积分信息
      tableData: [],
      form: {
        name: "",
        region: "",
        date1: "",
        date2: "",
        delivery: false,
        type: [],
        resource: "",
        desc: ""
      },
      formInline: {
        user: "",
        region: ""
      },
      queryInfo: {
        GFCrmID: this.$route.query.custID,
        pageNo: 1,
        pageSize: 20
      },
      total: 0,
      size: 0,
      pageSize: 0,
      loading: false
    };
  },
  created() {
    this.loading = true;
    this.getPointData();
    this.getTableData();
  },
  computed: {
    onLoading() {
      return this.loading || this.total < this.tableData.length;
    }
  },
  methods: {
    load() {
      setTimeout(() => {
        if (this.total > this.tableData.length) {
          this.queryInfo.pageNo += 1;
          this.getTableData();
        }
      }, 1000);
    },
    //获取列表数据
    getTableData() {
      this.loading = true;
      getPointTable(this.queryInfo).then(res => {
        console.log(res);
        this.tableData = this.tableData.concat(res.data.list);
        this.total = res.data.total;
        this.size = res.data.size;
        this.pageSize = res.data.pageSize;
        this.loading = false;
      });
    },

    //获取积分数据
    getPointData() {
      getPointInfo({
        GFCrmID: this.$route.query.custID
      }).then(res => {
        this.integralInfo = res.data;
      });
    },
    // 判断如果是单行就变黄色双行是白色
    tableRowClassName({ rowIndex }) {
      if (rowIndex % 2 === 1) {
        return "warning-row";
      }
      return "";
    },
    // 点击返回按钮  返回上一页面
    backHistory() {
      // this.$router.go(-1); //返回上一层
      this.$router.push({
        path: "/Examine",
        query: {
          custID: this.$route.query.custID
        }
      }); //返回GF管理查看
    }
  }
};
</script>
<style lang="scss" scoped>
#examineIntegrate {
}
.header {
  .header-text {
    width: 350px;
    height: 50px;
    margin-top: 20px;
    color: #76734f;
  }
  .card-pagination {
    height: 50px;
  }
}

.push-button {
  background-color: #e9e7d3;
}

// 按钮边框去掉，文字颜色和加粗
/deep/button {
  border-color: #e6e0af;
  border-radius: 7px;
  color: #a19b59;
}
/deep/input {
  height: 30px;
  border-radius: 0 !important;
}
::v-deep {
  // 表格隔行变色
  .el-table .warning-row {
    background: #fcfbf2;
  }

  .el-table .success-row {
    background: #ffffff;
  }
  // 改变分页背景色
  .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #d1cda5 !important;
    color: #ffffff !important;
  }
}
</style>
